import type { LangCode } from "@/api/types";

export function langTagLabel(lang: LangCode | null | undefined): string {
  switch (lang) {
    case "en":
      return "англ.";
    case "ru":
      return "рус.";
    case "la":
      return "лат.";
    default:
      return "";
  }
}

export function itemTypeLabel(t: string): string {
  switch (t) {
    case "abbreviation":
      return "аббревиатура";
    case "glossary_term":
      return "термин";
    case "alias_candidate":
      return "alias-кандидат";
    case "term_alias":
      return "alias";
    case "enforcement_candidate":
      return "enforcement-кандидат";
    case "eval_failure":
      return "проблема qa";
    default:
      return t;
  }
}

export function statusLabel(s: string): string {
  switch (s) {
    case "open":
      return "открыто";
    case "approved":
      return "принято";
    case "rejected":
      return "отклонено";
    case "needs_review":
      return "на ревью";
    case "needs_second_review":
      return "второй ревью";
    case "merged":
      return "объединено";
    case "deprecated":
      return "deprecated";
    default:
      return s;
  }
}

export function decisionLabel(d: string): string {
  switch (d) {
    case "approve":
      return "принято";
    case "edit_and_approve":
      return "изменено и принято";
    case "reject":
      return "отклонено";
    case "needs_review":
      return "на ревью";
    case "needs_second_review":
      return "второй ревью";
    case "skip":
      return "пропущено";
    case "mark_ambiguous":
      return "помечено неоднозначным";
    case "apply_draft":
      return "применён черновик";
    default:
      return d;
  }
}

export function hintTypeLabel(t: string): string {
  switch (t) {
    case "preferred":
      return "предпочтительно";
    case "acceptable":
      return "допустимо";
    case "forbidden":
      return "запрещено";
    default:
      return t;
  }
}

/** Локализация известных review-очередей. */
export function reviewQueueLabel(q: string): string {
  switch (q) {
    case "okhlp_mnn_salt_candidates":
      return "ОХЛП: соли и составные формы";
    case "okhlp_mnn_unmatched_high_evidence":
      return "ОХЛП: сильные кандидаты на МНН";
    case "okhlp_mnn_normalization_review":
      return "ОХЛП: нормализация МНН";
    case "abbreviation_candidates":
      return "Аббревиатуры — кандидаты";
    case "enforcement_candidates":
      return "Enforcement — кандидаты";
    case "alias_candidates":
      return "Alias — кандидаты";
    default:
      return q;
  }
}

/** Локализация причин ревью. */
export function reviewReasonLabel(r: string): string {
  switch (r) {
    case "salt_or_form_requires_review":
      return "соль или составная форма требует ревью";
    case "high_evidence_no_eaeu_match":
      return "сильные доказательства, без сопоставления EAEU";
    case "ambiguous_resolution":
      return "неоднозначное разрешение";
    case "blocked_source_term":
      return "запрещённый исходный термин";
    case "abbreviation_requires_review":
      return "аббревиатура требует ревью";
    default:
      return r;
  }
}

/** Контекстное описание задачи ревью по типу очереди — для info-banner. */
export function reviewContextHint(
  queue: string | undefined,
): { title: string; hint: string } | null {
  switch (queue) {
    case "okhlp_mnn_salt_candidates":
      return {
        title: "Нормализация соли / формы препарата",
        hint:
          "Запись из ОХЛП: русский МНН-кандидат с солевой/составной формой. " +
          "Задача — подтвердить или предложить EN-вариант для EAEU справочника. " +
          "Перевода backend не нашёл — введи или подтверди вручную через «Изменить и принять». " +
          "Без EN-варианта в /translate термин подсвечиваться не будет.",
      };
    case "okhlp_mnn_unmatched_high_evidence":
      return {
        title: "Сильный кандидат без EAEU-сопоставления",
        hint:
          "Русский МНН встречается в корпусе ОХЛП многократно, но в EAEU-словаре " +
          "его нет. Reviewer решает: принять с EN-вариантом (попадёт в EN→RU перевод), " +
          "принять без EN (только для domain-классификации), отклонить или на второй ревью. " +
          "Без EN-варианта в /translate термин подсвечиваться не будет — нет EN-surface для matching'а.",
      };
    case "okhlp_mnn_normalization_review":
      return {
        title: "Нормализация МНН в ОХЛП",
        hint:
          "RU-only ревью. EN-перевода может не быть — это не перевод, а нормализация формы. " +
          "Если EN не нужен, оставь поле пустым и нажми «Принять».",
      };
    default:
      return null;
  }
}

export function ruEnd(
  n: number,
  [one, few, many]: [string, string, string],
): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
